import { Controller } from 'stimulus';
import loadDatepicker from '../helpers/loadDatepicker';

/*
Usage:
<input
  data-controller="datepicker"
  data-datepicker-disabled-dates="20-01-2020,24-01-2020,28-01-2020"
  data-datepicker-disabled-days-of-week="0,6"
  data-datepicker-default-view-date="today"
  data-datepicker-start-view="2"
  data-datepicker-start-date="10-01-2020"
>
 */

class Datepicker extends Controller {
  connect() {
    loadDatepicker()
      .then(this.createDatePicker.bind(this));
  }

  createDatePicker() {
    $(this.element).datepicker(this.getOptions());
  }

  getOptions() {
    return {
      language: 'nl',
      datesDisabled: this.getOptionOrDefault('disabled-dates', []),
      daysOfWeekDisabled: this.getOptionOrDefault('disabled-days-of-week', []),
      defaultViewDate: this.getOptionOrDefault('default-view-date', 'today'),
      startView: this.getOptionOrDefault('start-view', 0),
      startDate: this.getOptionOrDefault('start-date', -Infinity),
    };
  }

  getOptionOrDefault(key, defaultValue) {
    return this.data.has(key)
      ? this.data.get(key)
      : defaultValue;
  }
}

export default Datepicker;
